import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { get } from "@src/appV2/api/api";
import {
  RejectionMappingsType,
  RejectionMappingsSchema,
} from "src/containers/requirements/rejectionMappingTab/api/types";
import { environmentConfig } from "src/appV2/environment";

const documentServiceRestApiUrl = environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL;

export function useGetRejectionMappings(
  options?: UseQueryOptions<RejectionMappingsType>
): UseQueryResult<RejectionMappingsType> {
  const url = `${documentServiceRestApiUrl}/rejection-mappings`;

  return useQuery({
    queryKey: [url],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await get({
        url,
        responseSchema: RejectionMappingsSchema,
      });
      return response.data;
    },
    enabled: options?.enabled ?? true,
    ...options,
  });
}
